import { TeamsState } from "containers/teams/redux/reducer";

const initialState: TeamsState = {
  subCategorySelected: "team",
  isFetchingTeamsForClient: false,
  isAssigningMobileUsersToTeams: false,
  isAssigningWebUsersToTeams: false,
  isAssigningWorkflowsToTeams: false,
  isUnAssigningWorkflowsFromTeams: false,
  isUnAssigningUsersFromTeams: false,
  isCreatingTeam: false,
  isCreatingTeams: false,
  isUpdatingTeam: false,
  isDeletingTeams: false,
  isArchivingTeams: false,
  isRestoringTeams: false,
  isBulkUpdatingHierarchy: false,
  selectedTeam: undefined,
  allTeams: [],
  allIds: [],
  errors: [],
};

export default initialState;
